import React, { useEffect } from "react";
import { FormGroup, Input, FormFeedback, Label } from "reactstrap";
import PopoverItem from "../common/PRpopover";

const PRInput = (props) => {
  useEffect(() => {
    // console.log(props);
  }, []);
  return (
    <>
      {props.elem.disable ? (
        ""
      ) : (
        <FormGroup>
          <Label className={props.elem.fontWeight ? "label-font" : ""}>
            {props.translate(props.lang, props.elem.label)}{" "}
            {!props.elem.required ? <span className="colorred">{props.translate(
                    props.lang,"optionalSign")}</span> : " "}
          </Label>
          <PopoverItem elem={props.elem} translate={props.translate} lang={props.lang}/>
               
          <Input
            key={props.elem.name}
            //type={(props.elem.name !== "additionalDetail") ? "input" : ((props.elem.name === "email")?"email":"textarea")}
                          type={(props.elem.name === "email") ? "email" : ((props.elem.name!== "additionalDetail") ? "input" : "textarea")}
            //autoComplete="off"
            disabled={props.disabled?"disabled":""}
            name={props.elem.name}
            id={props.elem.name}
            placeholder={props.placeholder ? ((props.translate(props.lang, props.placeholder) !== props.elem.name + "Placeholder") ? props.translate(props.lang, props.placeholder):"" ) : ""}
            value={(props.elem.value)?props.elem.value:""}
            valid={props.elem.status === 0}
            invalid={props.elem.status === 1}
            onClick={(e) => {
              props.validate(e);
            }}
            onChange={(e) => {
              props.validate(e);
            }}
          />
         

                      <FormFeedback>
                {props.elem.required && (!props.elem.value || props.elem.value==="")
              ? props.translate(props.lang,props.elem.label).replace(':','') +" "+ props.translate(props.lang,"isRequired")+'. '+
                " " +
                              (props.elem.errorlabel ? props.translate(props.lang, props.elem.errorlabel) : "")
              : ""}
          </FormFeedback>
        </FormGroup>
      )}
    </>
  );
};

export default PRInput;

// PRInput.propTypes = {
//   onChange: PropTypes.func.isRequired,
// };
